import { useTranslate } from "@opensea/next-translate"
import React from "react"
import { PageTrackingContextProvider } from "@/lib/analytics/TrackingContext/contexts/PageTrackingContext/PageTrackingContext.react"
import {
  useConnectedAddress,
  useConnectedChain,
} from "@/providers/Wallet/selectors"
import { UIProviders } from "@/providers/UIProviders"
import { TransactionList } from "../Transactions/TransactionList.react"

export function TransactionsPage() {
  const t = useTranslate("transactions")

  const address = useConnectedAddress()
  const chain = useConnectedChain()

  if (!chain || !address) {
    // TODO: Redirect to login page
    return null
  }

  return (
    <UIProviders>
      <PageTrackingContextProvider name="Activity">
        <div className="flex h-full flex-col pb-3 pt-6">
          <div className="mb-4 px-6 text-heading-md font-semibold">
            {t("transactionsPage.title", "Transactions")}
          </div>
          <TransactionList address={address} chain={chain} />
        </div>
      </PageTrackingContextProvider>
    </UIProviders>
  )
}
